<template>
  <div class="container">
    <div class="mwow-top-title">
      <span class="text">市场顾问推广</span>
    </div>
    <div class="head-btns">
      <el-button
        class="mwow-button-filled primary"
        @click="handleExport"
        v-debounce="1000"
        >导出</el-button
      >
    </div>

    <el-form class="mwow-wrap form" size="mini">
      <el-row>
        <el-col :span="8">
          <el-form-item label="市场顾问:" prop="title">
            <el-select
              v-model="searchInfo.market_staff_id"
              placeholder="请输入市场顾问姓名或手机号"
              clearable
              filterable
              :filter-method="handleSearchMarketStaff"
              @change="handleSearch"
            >
              <el-option
                v-for="item in market_staff_list"
                :key="item.staff_id"
                :label="item.name"
                :value="item.staff_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="创建时间:" prop="create_time">
            <common-date-range-selector
              v-model="searchInfo.create_time"
              start-placeholder="开始时间"
              range-separator="至"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              @change="handleSearch"
              :picker-options="effectiveDate"
            >
            </common-date-range-selector>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="市场顾问状态:" prop="status">
            <el-radio-group v-model="searchInfo.status" @change="handleSearch">
              <el-radio-button :label="-1">全部</el-radio-button>
              <el-radio-button :label="1">正常</el-radio-button>
              <el-radio-button :label="2">禁用</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="市场顾问类型:" prop="full_time">
            <el-radio-group
              v-model="searchInfo.full_time"
              @change="handleSearch"
            >
              <el-radio-button :label="-1">全部</el-radio-button>
              <el-radio-button :label="1">全职</el-radio-button>
              <el-radio-button :label="2">兼职</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <br />
    <el-table
      size="mini"
      :data="tableData"
      v-horizontal-scroll
      stripe
      style="width: 100%"
      tooltip-effect="dark"
      class="table"
      @sort-change="clickSort"
    >
      <el-table-column label="序号" type="index" width="50"> </el-table-column>
      <el-table-column label="市场顾问ID" prop="staff_id" width="90">
      </el-table-column>
      <el-table-column label="市场顾问姓名" prop="name" width="110">
      </el-table-column>
      <el-table-column label="市场顾问手机号" prop="mobile" width="110">
      </el-table-column>
      <el-table-column label="市场顾问类型" prop="full_time" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.full_time === 2">兼职</span>
          <span v-else-if="scope.row.full_time === 1">全职</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="推广活动数量" prop="activity_num" width="140">
      </el-table-column>
      <el-table-column
        label="销售金额"
        prop="sales_amount"
        width="100"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      >
      </el-table-column>
      <el-table-column
        label="进行中推广活动数量"
        prop="ongoing_activity_num"
        width="180"
      ></el-table-column>
      <el-table-column
        label="推广名单数"
        prop="roster_num"
        width="120"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      ></el-table-column>
      <el-table-column
        label="今日推广名单数"
        prop="today_roster_num"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      ></el-table-column>
      <el-table-column
        label="今日销售金额"
        prop="today_sales_amount"
        width="120"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      >
      </el-table-column>
      <el-table-column label="创建时间" prop="create_time"></el-table-column>
      <el-table-column
        label="市场顾问状态"
        prop="market_staff_status"
        width="100"
      >
        <template slot-scope="scope">
          {{ handleStaffStatus(scope) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="opreation" fixed="right" width="220">
        <template slot-scope="scope">
          <div class="btns">
            <el-button
              class="mwow-button info"
              @click="handleToPromotionList(scope)"
              >推广名单数</el-button
            >
            <el-button
              class="mwow-button info"
              @click="handleToSalesAmountDetail(scope)"
              >销售金额明细</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import {
  getMarketStaffListApi,
  exportMarketStaffListApi,
} from "@/api/marketActivity";
import { dateFormat } from "@/utils/timeFormat";
import { exportLoop } from "@/utils/export";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

export default {
  name: "salesAmountDetail",
  components: {
    commonDateRangeSelector,
  },
  data() {
    return {
      searchInfo: {
        status: -1,
        full_time: -1,
        sort_field: "create_time",
        sort_type: "desc",
      },
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      tableData: [],
      market_staff_list: [],
      effectiveDate: {
        disabledDate(date) {
          return date > Date.now();
        },
      },
      timer: "",
    };
  },
  created() {
    this.getList();
    this.getMarketStaffListApiFn();
  },
  methods: {
    solveSearchInfo(option) {
      let params = { ...option };
      if (this.searchInfo.market_staff_id) {
        params.market_staff_id = this.searchInfo.market_staff_id;
      }
      if (this.searchInfo.status > 0) {
        params.status = this.searchInfo.status;
      }
      if (this.searchInfo.full_time > 0) {
        params.full_time = this.searchInfo.full_time;
      }
      if (this.searchInfo.create_time) {
        params.create_start_time =
          new Date(this.searchInfo.create_time[0] + " 00:00:01").getTime() /
          1000;
        params.create_end_time =
          new Date(this.searchInfo.create_time[1] + " 23:59:59").getTime() /
          1000;
      }
      if (this.searchInfo.sort_type) {
        params.sort_type = this.searchInfo.sort_type;
      }
      if (this.searchInfo.sort_field) {
        params.sort_field = this.searchInfo.sort_field;
      }
      return params;
    },
    getList(params) {
      let option = this.solveSearchInfo(params);
      getMarketStaffListApi(option).then((res) => {
        if (res.error_code === 0) {
          res.data.list.forEach((item) => {
            item.create_time = item.create_time
              ? dateFormat(
                  "YYYY-mm-dd HH:MM",
                  new Date(item.create_time * 1000)
                )
              : "-";
          });
          this.tableData = [
            {
              staff_id: "-",
              name: "官方",
              mobile: "-",
              full_time: 1,
              activity_num: res.data.official.activity_num,
              sales_amount: res.data.official.sales_amount,
              ongoing_activity_num: res.data.official.ongoing_activity_num,
              roster_num: res.data.official.roster_num,
              today_roster_num: res.data.official.today_roster_num,
              today_sales_amount: res.data.official.today_sales_amount || "0",
              create_time: res.data.official.create_time
                ? dateFormat(
                    "YYYY-mm-dd HH:MM",
                    new Date(res.data.official.create_time * 1000)
                  )
                : "-",
              market_staff_status: 1,
              status: -1,
            },
            ...res.data.list,
          ];
          this.total = res.data.total;
        }
      });
    },

    // 获取市场顾问列表
    getMarketStaffListApiFn(v) {
      getMarketStaffListApi({
        page: 1,
        page_size: 100,
        keyword: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.market_staff_list = res.data.list;
        }
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    // 模糊搜索 - 市场顾问
    handleSearchMarketStaff(v) {
      this.debounce(this.getMarketStaffListApiFn, v, 500);
    },
    debounce(fn, data, delay) {
      // 设置一个触发开关
      let _t = this;
      clearTimeout(_t.timer);
      _t.timer = setTimeout(() => {
        fn(data);
      }, delay);
    },
    // 跳转推广名单
    handleToPromotionList(scope) {
      let query = {
        market_staff_id: scope.row.staff_id,
        name: scope.row.name,
      };
      if (scope.row.staff_id === "-") {
        query.market_staff_id = 0;
      }
      this.$router.push({
        name: "promotionList",
        query: query,
      });
    },
    // 跳转销售金额明细
    handleToSalesAmountDetail(scope) {
      let query = {
        market_staff_id: scope.row.staff_id,
        name: scope.row.name,
      };
      if (scope.row.staff_id === "-") {
        query.market_staff_id = 0;
      }
      this.$router.push({
        name: "salesAmountDetail",
        query: query,
      });
    },
    handleStaffStatus(scope) {
      if (scope.row.market_staff_status === 1) {
        return "正常";
      } else {
        if (scope.row.is_del === 2 && scope.row.status === 1) {
          return "调岗";
        } else {
          return "离职";
        }
      }
    },
    clickSort(e) {
      let sort = "desc";
      if (e.order == "descending") {
        sort = "desc";
      } else if (e.order == "ascending") {
        sort = "asc";
      }
      this.searchInfo.sort_type = sort;
      this.searchInfo.sort_field = e.prop;
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    handleExport() {
      let option = this.solveSearchInfo({
        page: this.page,
        page_size: this.pageSize,
      });
      exportMarketStaffListApi(option).then((res) => {
        if (res.error_code === 0) {
          exportLoop(res.data.task_id);
        }
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 70px 12px;
  border-radius: 4px;
  overflow: hidden;
  .head-btns {
    margin-top: 20px;
  }
}
/deep/.form {
  padding-top: 20px;
  .el-form-item {
    display: flex;
    .el-form-item__label {
      min-width: 100px !important;
    }
    .el-form-item__content {
      width: 74%;
      div:nth-child(1) {
        width: 100%;
      }
    }
  }
}

.table {
  .btns {
    display: flex;
  }
}
</style>
